module.exports = __webpack_public_path__ + "static/img/certificate05.6b2cc4cb.jpeg";